var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 2C0.333374 0.89543 1.2288 0 2.33337 0C3.43794 0 4.33337 0.89543 4.33337 2C4.33337 3.10457 3.43794 4 2.33337 4C1.2288 4 0.333374 3.10457 0.333374 2ZM2.33337 6C1.2288 6 0.333374 6.89543 0.333374 8C0.333374 9.10457 1.2288 10 2.33337 10C3.43794 10 4.33337 9.10457 4.33337 8C4.33337 6.89543 3.43794 6 2.33337 6ZM0.333374 14C0.333374 12.8954 1.2288 12 2.33337 12C3.43794 12 4.33337 12.8954 4.33337 14C4.33337 15.1046 3.43794 16 2.33337 16C1.2288 16 0.333374 15.1046 0.333374 14Z",
    fill: "#183028"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.4efa232f16bc41e54c3c8468d5a78d9e.svg";
export { ForwardRef as ReactComponent };